// Ideas de enlace del paso `custom-links` del onboarding: las usa la vista
// previa (enlaces de ejemplo) y el formulario (atajos que llenan el título y
// explican de dónde sacar la dirección).
export const LINK_SUGGESTIONS = {
    directions: {
        title: "Cómo llegar",
        icon: "📍",
        imageUrl: "/img/link-icons/map.svg",
        urlPlaceholder: "Ej: https://maps.app.goo.gl/...",
        hint: "En Google Maps busca tu negocio, toca Compartir y copia el enlace."
    },
    booking: {
        title: "Agenda tu cita",
        icon: "📅",
        imageUrl: "/img/link-icons/calendar.svg",
        urlPlaceholder: "Ej: https://calendly.com/tu-nombre",
        hint: "Copia el enlace de la agenda que usas (Calendly, Google Calendar u otra)."
    },
    reviews: {
        title: "Déjanos tu reseña",
        icon: "⭐",
        imageUrl: "/img/link-icons/star.svg",
        urlPlaceholder: "Ej: https://g.page/r/...",
        hint: "En tu perfil de empresa de Google toca Pedir reseñas y copia el enlace."
    },
    contact: {
        title: "Escríbenos por WhatsApp",
        icon: "💬",
        imageUrl: "/img/networks-icons/whatsapp.png",
        urlPlaceholder: "Ej: https://wa.me/573001234567",
        hint: "Escribe wa.me/ seguido de tu número con el indicativo, sin espacios."
    }
};

const LINK_SUGGESTIONS_BY_BUSINESS_TYPE = {
    share_only: ["booking", "reviews"],
    organization: ["directions", "contact"],
    social_seller: ["contact", "reviews"],
    single_store: ["directions", "reviews"],
    multi_store: ["directions", "reviews"]
};

const DEFAULT_LINK_SUGGESTIONS = ["directions", "reviews"];

// Primero las del tipo de negocio, después el resto.
export function linkSuggestionKeys(businessType) {
    const first =
        LINK_SUGGESTIONS_BY_BUSINESS_TYPE[businessType] ||
        DEFAULT_LINK_SUGGESTIONS;
    const rest = Object.keys(LINK_SUGGESTIONS).filter(
        (key) => !first.includes(key)
    );
    return [...first, ...rest];
}

export function sampleLinkSuggestionKeys(businessType) {
    return (
        LINK_SUGGESTIONS_BY_BUSINESS_TYPE[businessType] ||
        DEFAULT_LINK_SUGGESTIONS
    );
}
